import { Component, Input } from '@angular/core';
import { ItemLogDto } from '../../models/item-log-dto';
import { ItemLogService } from '../../services/item-log.service';
import { BaseComponent } from '../component-base';

@Component({
  selector: 'app-item-logs',
  templateUrl: './item-logs.component.html'
})
export class ItemLogsComponent extends BaseComponent {
  @Input() itemId: string;
  itemLogs: ItemLogDto[] = [];

  constructor(private itemLogService: ItemLogService) {
    super();
  }

  ngOnInit() {
    this.fillLogs();
  }

  fillLogs() {
    this.itemLogService.getItemLogs(this.itemId)
      .subscribe((response) => {
        if (response && response.success) {
          this.itemLogs = response.value;
        }
      });
  }
}
